import {
  ContentPage,
  ContentSection,
  ContactEmail,
  PostalAddress,
} from '../components/ContentPage.js';
import type { FooterView } from '../components/SiteFooter.js';
import { useT } from '../i18n/index.js';

/**
 * How to reach the person behind the site.
 *
 * The list of topics is not padding: a contact page that only gives an address
 * gets either nothing or everything. Saying what we can act on is what turns
 * "a film's year is wrong" from a shrug into a correction.
 */
export function ContactScreen({
  onBack,
  onNavigate,
}: {
  onBack: () => void;
  onNavigate: (view: FooterView) => void;
}) {
  const t = useT();

  return (
    <ContentPage
      view="contact"
      title={t('contact.title')}
      lead={t('contact.lead')}
      onBack={onBack}
      onNavigate={onNavigate}
    >
      <ContentSection title={t('contact.emailTitle')}>
        <p className="content__email">
          <ContactEmail />
        </p>
        <p>{t('contact.emailBody')}</p>
      </ContentSection>

      <ContentSection title={t('contact.topicsTitle')}>
        <ul className="content__list">
          <li>{t('contact.topicBug')}</li>
          <li>{t('contact.topicFilm')}</li>
          <li>{t('contact.topicAccount')}</li>
          <li>{t('contact.topicPrivacy')}</li>
          <li>{t('contact.topicAds')}</li>
        </ul>
      </ContentSection>

      <ContentSection title={t('contact.responseTitle')}>
        <p>{t('contact.responseBody')}</p>
      </ContentSection>

      <ContentSection title={t('contact.postalTitle')}>
        <p>{t('contact.postalBody')}</p>
        <PostalAddress />
      </ContentSection>
    </ContentPage>
  );
}
